import gql from "graphql-tag";
import graphqlClient, { fragments } from "@/http/graphql/card";

export const GET_TITLES = `
	titles (limit: $limit, page: $page) {
		data {
			...CardTitle
		}
		total
	}
`;

const ADD_TITLE = `
	create_title(name: $name, department_id: $department_id, description: $description, role_id: $role_id, is_lead: $is_lead) {
		...CardTitle
	}
`;

const UPDATE_TITLE = `
	update_title(id: $id, name: $name, department_id: $department_id, description: $description, role_id: $role_id, is_lead: $is_lead) {
		...CardTitle
	}
`;

const DELETE_TITLE = `
	delete_title(id: $id) {
		id
	}
`;
const BULK_UPDATE_TITLE = `
	update_titles(list: $list) {
		id
		name 
		is_lead
		role {
			id 
			name
		}
		department{
			id
			name
		}
	}`;
export default {
	init() {},

	fetchTitles(payload) {
		const queryOptions = {
			query: gql`query Titles ($limit: Int!, $page: Int!) {
				${GET_TITLES}
			}
			${fragments.CardTitle}
			`,
			variables: {
				limit: payload.limit || -1,
				page: payload.page || 1
			}
		};
		if (payload.fetchPolicy) {
			queryOptions.fetchPolicy = payload.fetchPolicy;
		}
		return graphqlClient.query(queryOptions).then(response => {
			return {
				titles: response.data.titles.data
			};
		});
	},
	updateTitle(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation TitlesManagementUpdate (
					$id: Int!,
					$role_id: Int,
					$name: String!,
					$is_lead: Boolean,
					$department_id: Int,
					$description: String
					) {
						${UPDATE_TITLE}
					}
					${fragments.CardTitle}
				`,
				variables: {
					id: payload.id,
					name: payload.name,
					is_lead: payload.is_lead,
					role_id: payload.role_id || 0,
					department_id: payload.department_id || null,
					description: payload.description || ""
				}
			})
			.then(response => {
				return { title: response.data.update_title };
			});
	},

	addTitle(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation TitlesManagementAdd (
					$name: String!,
					$role_id: Int,
					$is_lead: Boolean,
					$department_id: Int
					$description: String
					) {
						${ADD_TITLE}
					}
					${fragments.CardTitle}
				`,
				variables: {
					name: payload.name,
					is_lead: payload.is_lead,
					role_id: payload.role_id || 0,
					department_id: payload.department_id || null,
					description: payload.description || ""
				}
			})
			.then(response => {
				return { title: response.data.create_title };
			});
	},

	deleteTitle(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation TitlesManagementDelete (
					$id: Int!
					) {
						${DELETE_TITLE}
					}
				`,
				variables: {
					id: payload.id || null
				}
			})
			.then(response => {
				return { title: response.data.delete_title };
			});
	},
	bulkUpdateTitles(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation BulkUpdateTitle (
					$list: [TitleInput]!,
					
					) {
						${BULK_UPDATE_TITLE}
					}
				`,
				variables: {
					list: payload.list || []
				}
			})
			.then(response => {
				return { titles: response.data.update_titles };
			});
	}
};
